module.exports = __webpack_public_path__ + "static/media/debtca-logo.ababa7dc.png";